<template>
    <div
        class="lesson-locked-overlay"
        role="button"
        tabindex="0"
        @click.stop="openGenericPaywall"
        @keyup.enter.stop="openGenericPaywall"
    >
        <div class="lesson-locked-overlay__text">
            <img src="@/assets/icons/padlock.svg" alt="" class="lesson-locked-overlay__icon" />
            <p class="lesson-locked-overlay__title">THIS LESSON IS LOCKED</p>
        </div>
        <p class="lesson-locked-overlay__subtitle">Upgrade to premium to view</p>
    </div>
</template>

<script>
import lessonRecordAccess from "@/mixins/lesson-record-access";

export default {
    name: "lesson-locked-overlay",
    mixins: [lessonRecordAccess],
    props: {
        lesson: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.lesson-locked-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px 16px;
    background: rgba($green_0, 0.8);
    border: 1px solid $green_1;
    border-radius: $radius;
    pointer-events: auto;
    z-index: 1;
    font-family: canada-type-gibson, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    cursor: pointer;

    &:focus {
        outline: 0;
    }
}

.lesson-locked-overlay__icon {
    width: 18px;
    height: 22px;
    flex-shrink: 0;
}

.lesson-locked-overlay__text {
    display: flex;
    gap: 6px;
}

.lesson-locked-overlay__title {
    color: white;
}

.lesson-locked-overlay__subtitle {
    color: $green_3;
}
</style>
